import { selectors } from 'app-webtech-core/selectors';
import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

// populate as a key value pair:
// the channelid of the channel the User switched to
// and the type of video beng watched at time of channel change (content or ad).
// use ""pipe"" (|) as the delimiter
// newChannelID={channelid}|currentlyPlaying={"ad" or "content"}

// eslint-disable-next-line no-unused-vars
export const channelChangeBeacon = ({ payload }, prevState) => {
  const { newChannelID, currentlyPlaying, ...params } = payload;
  const { trackClipEvents } = selectors.playbackSession.properties(prevState);
  if (trackClipEvents) {
    return {
      hitType: HIT_TYPE.EVENT,
      eventCategory: EVENT_CATEGORIES.INTERACT,
      eventName: EVENT_NAMES.CHANNEL_CHANGE,
      label: `newChannelID=${newChannelID}|currentlyPlaying=${currentlyPlaying}`,
      ...params,
    };
  }
  return {
    hitType: HIT_TYPE.EVENT,
    eventCategory: EVENT_CATEGORIES.INTERACT,
    eventName: EVENT_NAMES.CHANNEL_CHANGE,
    label: `newChannelID=${newChannelID}|currentlyPlaying=${currentlyPlaying}`,
  };
};
